export default "__VITE_ASSET__Bv7SUS1e__"